import React from "react";
import { Alert, ButtonSwitch, Col, Label, Row } from "@intech/web-ui";
import { WebAreaFundacaoEntidade } from "@entidades";

interface IProps {
  setores: Array<WebAreaFundacaoEntidade>;
  onChange: React.Dispatch<React.SetStateAction<number>>;
  oidAtivo: number;
}

export const Setores: React.FC<IProps> = ({
  setores,
  onChange,
  oidAtivo
}) => {
  return (
    <div className={"form-group"} >
      <Row>
        <Label
          value={"Setores"}
          size={2}
          required
        />
        {setores.length > 0 &&
          <Col>
            <Row>
              {setores.map((setor: WebAreaFundacaoEntidade, index: number) => (
                <Col key={index}>
                  <ButtonSwitch
                    activeType={"success"}
                    inactiveType={"light"}
                    inactiveIcon={" "}
                    activeTitle={setor.DES_AREA_FUNDACAO}
                    inactiveTitle={setor.DES_AREA_FUNDACAO}
                    checked={setor.OID_AREA_FUNDACAO === oidAtivo}
                    onChange={() => onChange(setor.OID_AREA_FUNDACAO)}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        }

        {setores.length === 0 &&
          <Col>
            <Row>
              <Col>
                <Alert type={"danger"}>{"Nenhum setor cadastrado no sistema."}</Alert>
              </Col>
            </Row>
          </Col>
        }
      </Row>
    </div>
  );
}